import { useContext } from 'react';
import CursorContext from '../components/providers/Cursor';

/**
 * Handlers para que el cursor custom (Container.jsx) tome el estilo correcto
 * según el fondo de la sección: punto crema en secciones oscuras, anillo
 * "Scroll" en secciones claras.
 *
 * Se usa onMouseMove en vez de onMouseEnter para que el cursor vuelva al
 * estilo de la sección apenas sale de un botón o link (que ponen su propio
 * estilo al entrar). React descarta el setState cuando el valor no cambia,
 * así que llamarlo en cada movimiento no re-renderiza.
 */
export default function useCursorZone(tone = 'dark') {
    const { blackSectionEnter, blackSectionExit, selectExit } = useContext(CursorContext);

    const onMouseMove = (e) => {
        if (e.target.closest('a, button, input, textarea, select, label, [data-cursor]')) return;
        if (tone === 'dark') blackSectionEnter();
        else selectExit();
    };

    return { onMouseMove, onMouseLeave: blackSectionExit };
}
